import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { objectNotEmpty } from '../../../utilities/helpers';
import { boundariesCriteria, organisationTabCriteria, mobileAppCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_BRAND_AFFINITY_CATEGORIES_REPORT,
  FETCH_BRAND_AFFINITY_CATEGORIES_REPORT_ERROR,
  SET_BRAND_AFFINITY_CATEGORIES_REPORT
} from '../../constants';

const categoriesReport = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_BRAND_AFFINITY_CATEGORIES_REPORT),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/brand-affinity/categories?${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }${
            objectNotEmpty(state$.value.insightsCriteria.baseline) === true
            ? `&baseline=${state$.value.insightsCriteria.baseline.value}`
            : ''
          }${
            mobileAppCriteria(state$)
          }${
          `&period=${state$.value.brandAffinity.selectedPeriod.value}`
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_BRAND_AFFINITY_CATEGORIES_REPORT,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_BRAND_AFFINITY_CATEGORIES_REPORT_ERROR,
            error,
          })
        )
      )
    )
  );

export default categoriesReport;
